import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_URI } from 'src/environments/app.config';
import { Observable } from 'rxjs/Observable';
import { BaseService } from 'src/app/services/base.service';
import { Agent } from 'src/app/services/models/agent/agent.model';
import {Response} from 'src/app/services/models/response.model'
import {AgentCreateRequest} from 'src/app/services/models/agent/agent.create.request.model'
import {AgentUpdateRequest} from 'src/app/services/models/agent/agent.update.request.model'
import {AgentDepositRequest} from 'src/app/services/models/agent/agent.deposit.request.model'
import { AgentWithdrawRequest } from './models/agent/agent.withdraw.request.model';

@Injectable()
export class AgentService extends BaseService {
  constructor(private _http: HttpClient) {
    super(_http);
    this.baseUrl =  API_URI.agent;
  }

  createAgent(agentDetail: AgentCreateRequest): Observable<Response<Agent>> {
    agentDetail.Address = agentDetail.Address.trim();
    agentDetail.AgentName = agentDetail.AgentName.trim();
    agentDetail.Email = agentDetail.Email.trim();
    agentDetail.PhoneNumber = agentDetail.PhoneNumber.trim();

    return this.post(`/CreateAgent`, agentDetail, {})
    .map(result => new Response<Agent>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  updateAgentInfo(agentDetail: AgentUpdateRequest): Observable<Response<Agent>> {
    agentDetail.Address = agentDetail.Address.trim();
    agentDetail.AgentName = agentDetail.AgentName.trim();
    agentDetail.Email = agentDetail.Email.trim();
    agentDetail.PhoneNumber = agentDetail.PhoneNumber.trim();
    return this.post(`/UpdateAgentInfo`, agentDetail, {})    
    .map(result => new Response<Agent>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  getCurrentAgent(): Observable<Response<Agent>> {
    let url = `/CurrentAgent`;
    return this.get(url)
    .map(result => new Response<Agent>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  searchAgent(agentName:string, phoneNumber:string, address:string, agentID?:number, status?:number,): Observable<Response<Agent[]>> {
    agentName = agentName.trim();
    phoneNumber = phoneNumber.trim();
    address = address.trim();

    let url = `/SearchAgent?agentName=${encodeURIComponent(agentName)}&phoneNumber=${encodeURIComponent(phoneNumber)}&address=${encodeURIComponent(address)}`;
    if(agentID !== undefined)
    {
      url = url + `&&agentID=${agentID}`;
    }
    if(status !== -1)
    {
      url = url + `&status=${status}`;
    }
    return this.get(url)
    .map(result => new Response<Agent[]>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  agentBalance(agentName:string, phoneNumber:string, address:string, agentID?:number, status?:number,): Observable<Response<Agent[]>> {
    agentName = agentName.trim();
    phoneNumber = phoneNumber.trim();
    address = address.trim();
    let url = `/AgentBalance?AgentName=${encodeURIComponent(agentName)}&Status=${status}&PhoneNumber=${encodeURIComponent(phoneNumber)}&Address=${encodeURIComponent(address)}`;
    //if(status !== -1 && status !== undefined)
    //{
    //  url = url + `&status=${status}`;
    //}
    if(agentID !== undefined)
    {
      url = url + `&agentID=${agentID}`;
    }
    return this.get(url)
    .map(result => new Response<Agent[]>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }


  depositAgent(agentDeposit: AgentDepositRequest): Observable<Response<Agent>> {
    return this.post(`/DepositAgent`, agentDeposit, {})
    .map(result => new Response<Agent>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  withrawAgent(agentDeposit: AgentWithdrawRequest): Observable<Response<Agent>> {
    return this.post(`/WithrawAgent`, agentDeposit, {})
    .map(result => new Response<Agent>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }
}
